
import { Component, Vue, Prop } from 'vue-property-decorator';

import Trail from './Trail.vue'
import RightTurn from './RightTurn.vue'
import LeftTurn from './LeftTurn.vue'

@Component({
    components:{
        Trail,
        RightTurn,
        LeftTurn
    }
})
export default class ReturnTrail extends Vue {

    @Prop({required: false})
    status!: string;

    @Prop({required: false})
    startpoint!: string;

    @Prop({required: false})
    top!: string;

    @Prop({required: false})
    extendEnd!: boolean;

    @Prop({required: false})
    extendBegin!: boolean;

    @Prop({required: true})
    returnLevel!: number;

}
